export const isNumeric = (value: string | number): boolean => !Number.isNaN(+value);

export const getFileExt = (value: string): string => value.split(".").pop();
